import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {BenefitsRoutingModule} from './benefits-routing.module';
import {BenefitsComponent} from './benefits.component';
import {ComponentsModule} from "../../components/components.module";
import {TranslateModule} from "@ngx-translate/core";
import { InputComponent } from "../../components/input/input.component";
import { SelectComponent } from "../../components/select/select.component";
import { HeaderBenefitsComponent } from '../../components/header-benefits/header-benefits.component'
import { DiscoverBenefitsComponent } from '../../components/discover-benefits/discover-benefits.component'
import { FaqBenefitsComponent } from '../../components/faq-benefits/faq-benefits.component'


@NgModule({
    declarations: [
        BenefitsComponent
    ],
    imports: [
        CommonModule,
        BenefitsRoutingModule,
        TranslateModule.forChild(),
        InputComponent,
        SelectComponent,
        HeaderBenefitsComponent,
        DiscoverBenefitsComponent,
        FaqBenefitsComponent
    ]
})
export class BenefitsModule {
}
